import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import './Print.css';
import PdfStore from '../../stores/PdfStore'
import Moment from 'moment';

// var MobileDetect = require('mobile-detect')
var NotificationSystem = require('react-notification-system');
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543);
class PrintPaymentNoteDoc extends Component {

  constructor(props){
    super(props)

    this.state = {
      data:{itemlist:[]},
      report_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {added_by:'',added_date:'',bf_work_damage_id:'',cost_per_unit:'',detail:'',discount_amount:'',discount_percent:'',export_stock_flag:'',fix_flag:'',itemnum:'',paint_flag:'',part_cost:'',part_flag:'',part_from:'',price_on_shop:'',price_per_unit:'',productcode:'',quantity:'',row_style:'',seq:'',stock_flag:'',wage_cost:'',wage_itemnum:'',wait_insurer_flag:'',work_no:''}
    })
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    PdfStore.loadPaymentNoteDoc(this.props.pnNo,(result) => {
      let data = result.data
      if (data.itemlist.length===0) {
        data.itemlist = this.newEmptyRow(5)
      } else {
        if (5>data.itemlist.length) {
          data.itemlist = data.itemlist.concat(this.newEmptyRow(5 - data.itemlist.length))
        } else {
          data.itemlist = data.itemlist
        }  
      }
  
      this.setState({report_title:'ไม่พบข้อมูล',data:data})
    },()=>{
      this.setState({report_title:'เกิดข้อผิดพลาด'})
    })
  }

  getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV === "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/img/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img alt='' src={imgUrl} style={{border:'none'}} />)
  }
  
  renderHeader() {
    let {data} = this.state
    return([
              <header style={{position:'absolute',right:'20px'}} key={'_H'}>
                <h2 className='font-print-40'>{this.props.title}</h2>
              </header>,  
              <article className={"article-company "+data.logo_class} key={'_A'}>
                <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
                  {this.renderLogoUrl(data.logo_url)}
                </div>
                <section style={{paddingTop:(data.logo_class==='bg-logo-absolute'?'0':'15px')}}>
                  <strong>
                    <p className="font-header" style={{lineHeight:'0.7'}}>บริษัท {(data.company_name!==undefined?data.company_name:'')}</p>
                    <p className="font-header" style={{lineHeight:'0.7'}}>{data.company_addr!==undefined?data.company_addr:''}</p>
                    <p className="font-header" style={{lineHeight:'0.7'}}>โทร {(data.company_tel!==undefined?data.company_tel:'')}</p>              
                  </strong>
                </section>
              </article>
    ])
  }

  renderBody() {
    let {data} = this.state
    return(
          <div style={{width:'100%'}}>
      		<div style={{display:'inline-block',width:'69.5%',border:'1px solid',marginBottom:'5px',marginRight:'0.5%',height:'100px'}}>
	          <table className='table table-header-print-payment-note-doc' style={{marginBottom:'0'}}>
	            <tbody>
	              <tr>
	                <td className='font-print-24'>ชื่อลูกค้า {data.customer_name}</td>
	              </tr>
                <tr>
	                <td className='font-print-24'>ที่อยู่ {data.customer_address}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>
	        <div style={{display:'inline-block',width:'29.5%',border:'1px solid',marginBottom:'5px',marginLeft:'0.5%',height:'100px'}}>
	          <table className='table table-header-print-payment-note-doc' style={{marginBottom:'0'}}>
	            <tbody>
	              <tr>
	                <td className='font-print-24' style={{width:'100px'}}>เลขที่</td>
	                <td className='font-print-24'>{this.props.pnNo}</td>
	              </tr>
	              <tr>
	                <td className='font-print-24' style={{width:'100px'}}>วัน/เดือน/ปี</td>
	                <td className='font-print-24'>{TODAY}</td>
	              </tr>
	            </tbody>
	          </table>
	        </div>  
      	</div>
    )
  }

  renderTable() {
    // let {data} = this.state
    return(
          <div>
            <table className='table table-print-payment-note-doc'>
              <tbody>
                <tr>
                  <td className='text-center font-print-24' style={{width:'50px'}}>ลำดับ</td>
                  <td className='text-center font-print-24' style={{width:'400px'}}>รายการ</td>
                  <td className='text-center font-print-24' style={{width:'90px'}}>จำนวน</td>
                  <td className='text-center font-print-24' style={{width:'90px'}}>ราคาต่อ<br/>หน่วย</td>
                  <td className='text-center font-print-24' style={{width:'100px'}}>จำนวนเงิน</td>
                </tr>
                {this.renderRowData()}
              </tbody>
            </table>
          </div>
    )        
  }

  renderRowData() {
    let {data} = this.state

    //data.itemlist = this.newEmptyRow(5)
    return(
      data.itemlist.map((item,index) => {
        return(
          <tr key={index}>
            <td className='font-print-24 text-center'>{index+1}</td>
            <td className='font-print-24'>{item.detail}</td>
            <td className='font-print-24 text-center'>{item.quantity}</td>
            <td className='font-print-24 text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
            <td className='font-print-24 text-right'>{this.getNumberFormat(item.amount)}</td>
          </tr>
        )
      })
    )
  }

  // getTotalPerRow(quantity,price_per_unit) {
  //   let sum = 0
  //   if (quantity===''||quantity===null||quantity===undefined||isNaN(quantity))
  //     quantity = 0

  //   if (price_per_unit===''||price_per_unit===null||price_per_unit===undefined||isNaN(price_per_unit))
  //     price_per_unit = 0

  //   sum = parseFloat(quantity) * parseFloat(price_per_unit)
  //   return parseFloat(sum)
  // }

  // getTotal() {
  //   let {data} = this.state
  //   let sum = 0
  //   let that = this
  //   data.itemlist.forEach(function(item,index) {
  //     sum += parseFloat(that.getTotalPerRow(item.quantity,item.price_per_unit))
  //   })

  //   return parseFloat(sum)
  // }

  // getDiscountAmount() {
  //   let {data} = this.state
  //   let sum = 0
  //   let discount = 0
  //   let that = this
  //   data.itemlist.forEach(function(item,index) {
  //     discount = item.discount_amount
  //     if (discount===''||discount===null||discount===undefined||isNaN(discount))
  //       discount = 0

  //     sum += parseFloat(discount)
  //   })

  //   return parseFloat(sum)
  // }

  // getTotalAfterDiscount() {
  //   let sum = 0
  //   sum = this.getTotal() - this.getDiscountAmount()
  //   return parseFloat(sum)
  // }

  // getVat() {
  //   let sum = 0
  //   sum = (this.getTotalAfterDiscount() * 7) / 100
  //   return parseFloat(sum)
  // }

  // getNetTotal() {
  //   let sum = 0
  //   sum = parseFloat(this.getTotalAfterDiscount()) + parseFloat(this.getVat())
  //   return parseFloat(sum)
  // }

  // getThaiFormat() { 
  //   return ''
  // }

  renderRowSummary() {
    return([
      <tr key={0}>
        <td className='font-print-24' colSpan={2} rowSpan={4}>หมายเหตุ</td>
        <td className='font-print-24' colSpan={2}>รวมเป็นเงิน</td>
        <td className='font-print-24 text-right'>{this.getNumberFormat(this.getTotal())}</td>
      </tr>,
      <tr key={1}>
        <td className='font-print-24' colSpan={2}>หักส่วนลด <span className='font-print-24' style={{float:'right'}}>{this.getNumberFormat(this.getDiscountAmount())}</span></td>
        <td className='font-print-24 text-right'>{this.getNumberFormat(this.getDiscountAmount())}</td>
      </tr>,
      <tr key={2}>
        <td className='font-print-24' colSpan={2}>จำนวนเงินหลังหักส่วนลด</td>
        <td className='font-print-24 text-right'>{this.getNumberFormat(this.getTotalAfterDiscount())}</td>
      </tr>,
      <tr key={3}>
        <td className='font-print-24' colSpan={2}>จำนวนภาษีมูลค่าเพิ่ม <span className='font-print-24' style={{float:'right'}}>7.00%</span></td>
        <td className='font-print-24 text-right'>{this.getNumberFormat(this.getVat())}</td>
      </tr>,
      <tr key={4}>
        <td className='font-print-24 text-center' colSpan={2}>({this.getThaiFormat()})</td>
        <td className='font-print-24 text-center' colSpan={2}>จำนวนเงินรวมทั้งสิ้น</td>
        <td className='font-print-24 text-right'>{this.getNumberFormat(this.getNetTotal())}</td>
      </tr>
    ])
  }

  renderSignature() {
    return(
      	<div className='footer-page'>
      	  <table className='table table-header-print-payment-note-doc'>
      	    <tbody>
		      <tr>
		        <td style={{width:'40%'}} className='text-center font-print-24'>
		          ......................................................<br/>
		          ผู้จ่ายเงิน<br/>
		          วันที่ / Date.................................. 
		        </td>
		        <td style={{width:'60%'}}></td>
		      </tr>
		    </tbody>  
		  </table>    
	    </div>  
    )
  }

  renderComponentPage() {
    // let {data} = this.state
    return(
            <div className='font-print'>
              <div className="no-of-page">
                <span></span>
              </div>
              {this.renderHeader()}
              {this.renderBody()}
              {this.renderTable()}
              {this.renderSignature()}
            </div>
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render(){    
    // let {data} = this.state
    return (
        <div>
          <PrintPreview
            leftBarTitle={this.props.title+' '+this.props.pnNo}
          >
            {this.renderComponentPage()}
          </PrintPreview>
          <NotificationSystem ref="notificationSystem" />
        </div>
    )  
  }
}

PrintPaymentNoteDoc.defaultProps = {
  title: 'ใบบันทึกการรับเงิน',  
  mode : '1'
}

export default PrintPaymentNoteDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintPaymentNoteDoc.js